import { useSyncExternalStore } from 'react'

// WHAT IS BEING WORKED (owner, 2026-10-07: "see a spinner next to the name as it's being worked"). A crafting session is one
// account, one person, one opportunity; while a message of the rep's is with Scout, the session is working, wherever the
// rep has navigated to. One small store, outside React, so the menu and the page read the same truth; pure enough to test.

export function sessionKey(companyId: string, personId?: string | null, engagementId?: string | null): string {
  return `${companyId}|${personId ?? ''}|${engagementId ?? ''}`
}

const working = new Map<string, string>()
const listeners = new Set<() => void>()
let snapshot: ReadonlyMap<string, string> = new Map()

function changed() { snapshot = new Map(working); for (const l of listeners) l() }

export const work = {
  start(key: string, label: string) { working.set(key, label); changed() },
  end(key: string) { if (working.delete(key)) changed() },
  has(key: string) { return working.has(key) },
  /** everything in flight, for tests and the menu */
  all(): ReadonlyMap<string, string> { return snapshot },
  reset() { working.clear(); changed() },
}

function subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l) } }

/** The sessions being worked right now, keyed by session; re-renders when one starts or ends. */
export function useWorking(): ReadonlyMap<string, string> {
  return useSyncExternalStore(subscribe, () => snapshot, () => snapshot)
}
